import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { ScopeSelector } from "@packages/core-client/scope/ScopeSelector.tsx";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAnalyticsScopeClient } from "../api/query.ts";
import { useAnalyticsTracking } from "../hooks/useAnalyticsTracking.ts";
import { type FeedbackPeriod, getFeedbackDataFloor } from "../hooks/feedbackPeriod.ts";
import { useFeedbackPeriod, useFeedbackScope } from "../hooks/useFeedbackFilters.ts";
import { FeedbackPeriodToolbar } from "./FeedbackPeriodToolbar.tsx";
import { FeedbackFilterBar } from "./FeedbackFilterBar.tsx";

export function FeedbackFiltersHeading() {
    const [scope, setScope] = useFeedbackScope();
    const [period, setPeriod] = useFeedbackPeriod(scope);
    const scopeClient = useAnalyticsScopeClient();
    const { trackTimeRangeApplied } = useAnalyticsTracking();

    const { data: previews, isPending } = useQuery(createQueryOptions(scopeClient.getPreviews.queryOptions(), { throwOnError: false }));

    const handlePeriodChange = useCallback(
        (next: FeedbackPeriod) => {
            setPeriod(next);
            trackTimeRangeApplied(next.kind === "preset" ? next.timeFrame : next.kind);
        },
        [setPeriod, trackTimeRangeApplied]
    );

    return (
        <ScopeSelector
            scope={scope}
            onScopeChange={setScope}
            previews={previews}
            isPreviewsPending={isPending}
            trailingContent={
                <div className="flex flex-wrap items-center gap-2">
                    <FeedbackPeriodToolbar period={period} onPeriodChange={handlePeriodChange} dataFloor={getFeedbackDataFloor(scope)} />
                    <FeedbackFilterBar />
                </div>
            }
        />
    );
}
